import axios from 'axios';
import { API_URL } from '../../lib/const';
import { getAxiosConfig } from '../../lib/auth';

export const fetchAppropriations = (enrollmentId) => (
  axios.get(
    `${API_URL}/onboarding/document-approval-appropriations`,
    {
      params: {
        enrollment: enrollmentId,
        ordering: '-start_date',
      },
    }
  )
    .then(response => response.data)
);

export const createAppropriation = (enrollmentId) => (
  axios.post(
    `${API_URL}/onboarding/document-approval-appropriations`,
    {
      enrollment: enrollmentId,
    },
  )
    .then(response => response.data)
);

export const transferAppropriation = (appropriationId, userId) => (
  axios.post(
    `${API_URL}/onboarding/document-approval-appropriations/${appropriationId}/transfer`,
    {
      user: userId,
    },
  )
    .then(response => response.data)
);
